const TickIconV2 = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
    <path
      d="M18.5654 4.83269C18.8115 5.0876 18.8115 5.50698 18.5654 5.7619L7.94103 16.9454C7.69886 17.2044 7.30044 17.2044 7.05827 16.9454L1.43304 11.0247C1.18899 10.7698 1.18899 10.3504 1.43304 10.0955C1.67693 9.83647 2.07261 9.83647 2.31674 10.0955L7.49965 15.5516L17.6827 4.83269C17.9249 4.5753 18.3233 4.5753 18.5654 4.83269Z"
      fill="#111928"
    />
  </svg>
);

export default TickIconV2;
